import React, { useMemo } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler);

/** 与 aicopy 策略列表卡片一致；SSR 时无 document，不渲染图表直至客户端 */
export default function ReturnRateChart({ data }) {
  const chartData = useMemo(() => {
    if (!data || data.length === 0) return null;
    if (typeof document === "undefined") return null;

    const returnRates = data.map((item) => parseFloat(item.returnRate || 0));
    const values = returnRates.length === 1 ? [returnRates[0], returnRates[0]] : returnRates;

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return null;
    const gradient = ctx.createLinearGradient(0, 0, 0, 60);
    gradient.addColorStop(0, "rgba(36, 219, 87, 0.25)");
    gradient.addColorStop(1, "rgba(36, 219, 87, 0)");

    return {
      labels: values.map((_, index) => index),
      datasets: [
        {
          label: "return",
          data: values,
          borderColor: "#24DB57",
          backgroundColor: gradient,
          fill: true,
          tension: 0.4,
          pointRadius: 0,
          pointHoverRadius: 0,
          borderWidth: 2,
        },
      ],
    };
  }, [data]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 0 },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    scales: {
      x: { display: false, grid: { display: false } },
      y: { display: false, grid: { display: false } },
    },
  };

  if (!chartData) return null;

  return <Line data={chartData} options={options} />;
}
